import React, {ChangeEvent, useEffect, useState} from 'react';
import AppPlaceholder from '../../../assets/images/icons/app-media-placeholder.svg';
import {SingleAppModel} from '../models/response/single-app.model';
import {InputNumber} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {useDispatch, useSelector} from "react-redux";
import {fetchWorkHubMonthlyRental} from '../../../store/actions';
import {workHubLicenseTypes} from "../../../enum";
import {getWorkHubLicenseTypes} from "../../../services/workhub.service";

type Props = {
    appDetails: SingleAppModel;
    onChangeUsageCount: (e: any) => void;
    usageCount: string;
    onChangeWidgetCount: (value: any, rate: any) => void;
    onChangeLicenseCount: (value: number) => void;
    onChangeLicenseType: (value: string) => void;
    maxWidgetCount: number;
    validator: SimpleReactValidator;
}

const PanelTableListCard = ({
                                appDetails,
                                onChangeUsageCount,
                                usageCount,
                                onChangeWidgetCount,
                                onChangeLicenseCount,
                                onChangeLicenseType,
                                maxWidgetCount,
                                validator
                            }: Props) => {

    const [licenses, setLicenses] = useState<any[]>([]);
    const [widgetCount, setWidgetCount] = useState<number | undefined>(undefined);
    const [licenseType, setLicenseType] = useState<string>('');
    const [licenseCount, setLicenseCount] = useState<number | undefined>(undefined);
    const [, forceUpdate] = useState(0);

    const dispatch = useDispatch();

    const licenseMin = licenseType === workHubLicenseTypes.CONCURRENT_USER ? 25 : 1;
    const licenseMax = 1000;

    const isBelowMin =
        licenseCount !== null &&
        licenseCount !== undefined &&
        licenseCount < licenseMin;

    const isAboveMax =
        licenseCount !== null &&
        licenseCount !== undefined &&
        licenseCount > licenseMax;

    let licenseWarningMessage = '';

    if (isAboveMax) {
        licenseWarningMessage = `Maximum license count allowed is ${licenseMax}.`;
    } else if (isBelowMin) {
        licenseWarningMessage =
            licenseType === workHubLicenseTypes.CONCURRENT_USER
                ? `Minimum license count for Concurrent User is ${licenseMin}.`
                : `Minimum license count for Named User is ${licenseMin}.`;
    }

    const showLicenseWarning = isBelowMin || isAboveMax;

    const monthlyRentalData = useSelector((state: any) => state.workhub?.monthlyRentalData ?? null);

    useEffect(() => {
        const fetchLicenses = async () => {
            try {
                const response = await getWorkHubLicenseTypes();
                setLicenses(response.data)
            } catch (error) {
                console.error("Error fetching license types:", error);
            }
        }
        fetchLicenses();
    }, []);

    useEffect(() => {
        const widgetUuid = appDetails?.widgetDetails?.uuid;
        const minLicense = licenseType === workHubLicenseTypes.CONCURRENT_USER ? 25 : 0;

        if (licenseType && licenseCount !== undefined && licenseCount >= minLicense && widgetUuid) {
            dispatch<any>(fetchWorkHubMonthlyRental(widgetUuid, licenseType, licenseCount.toString()));
        }
    }, [licenseType, licenseCount, appDetails?.widgetDetails?.uuid, dispatch]);

    useEffect(() => {
        setWidgetCount(maxWidgetCount);
    }, [maxWidgetCount]);

    const getLicenseMin = () => {
        if (licenseType === 'concurrent user') return 25;
        return 1;
    };

    const handleLicenseTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const newType = e.target.value;
        setLicenseType(newType);
        onChangeLicenseType(newType);

        setLicenseCount(undefined);

        validator.showMessageFor('licenseType');
        validator.showMessageFor('license count');
    };

    const handleLicenseCountChange = (value: number | null) => {
        const v = Number(value ?? 0);

        setLicenseCount(v);
        onChangeLicenseCount(v);
    };

    return (
        <>
            <>
                <br></br>
                <h5 style={{textAlign: "left"}}>Monthly Charge</h5>
                <div className="panel-table-content-list group-list">
                    {['Named User', 'Concurrent User'].map((type) => (
                        <div key={type}>
                            <br/>
                            <div className="feature-details-title__wrapper no-shade billing-and-plans-package-select">
                                <span className="title" style={{margin: 12}}>
                                    <strong>{type}</strong>
                                </span>
                            </div>
                            <br/>
                            {licenses
                                .filter((item) => item.licenseType === type)
                                .map((item) => (
                                    <div className="panel-table-list-item card" key={item.uuid}>
                                        <div className="panel-table-listing-item__inner">
                                            <div className="feature-details__wrapper">
                                                <div
                                                    className="card app-media-holder"
                                                    style={{backgroundImage: `url(${AppPlaceholder})`}}
                                                ></div>
                                                <div
                                                    className="feature-details-title__wrapper no-shade billing-and-plans-package-select">
                                                    <span className="title">{item.title}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-table-listing-item__inner">
                                            <div className="panel-table-right-align-item__wrapper">
                                                <div className="panel-table-right-align-item">
                                                    <span className="title">Rs. {item.rental}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    ))}
                </div>
            </>
            <br></br>
            <div className="panel-table-content-list">
                <h5 style={{textAlign: "left"}}>Setup Fee</h5>
                <br></br>
                <div className="panel-table-list-item card">
                    <div className="panel-table-listing-item__inner">
                        <div className="feature-details__wrapper">
                            <div className="feature-details-title__wrapper no-shade">
                                <span className="title">Hosting & License, Implementation and Other Fees + Tax</span>
                                <span className="small-desc">Setup Fee</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br></br>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3">
                        <label htmlFor="licenseType" className="form-label">
                            Select the license type below.
                        </label>

                        <div className="icon-inside left d-flex btn-with-group">
                            <select
                                id="licenseType"
                                className="form-control"
                                onChange={handleLicenseTypeChange}
                                value={licenseType}
                            >
                                <option value="" disabled hidden>
                                    Select license type
                                </option>
                                <option value={workHubLicenseTypes.NAMED_USER}>Named User</option>
                                <option value={workHubLicenseTypes.CONCURRENT_USER}>Concurrent User</option>
                            </select>
                        </div>

                        <div className="validation invalid-feedback">
                            {validator.message('licenseType', licenseType, 'required')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3 ">
                        <label htmlFor="" className="form-label">
                            Enter the number of workflows to be activated for your subscription.
                        </label>
                        <div className="icon-inside left d-flex btn-with-group">
                            <InputNumber
                                style={{width: "50%"}}
                                min={1}
                                max={5}
                                precision={0}
                                step={1}
                                inputMode="numeric"
                                value={widgetCount}
                                placeholder="Enter workflow count"
                                onChange={(value) => {
                                    const v = Number(value ?? 0);
                                    setWidgetCount(v);
                                    onChangeWidgetCount(v, appDetails);
                                }}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            />
                        </div>
                        <div className="validation invalid-feedback">
                            {validator.message('workflow count', widgetCount?.toString(), 'required|numeric|min:1')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3 ">
                        <label htmlFor="" className="form-label">
                            Enter the number of licenses.
                        </label>
                        <div className="form-element__wrapper mb-3 ">
                            <small style={{marginBottom: 20}}><em>Note: License cost will be calculated based on the
                                number of licenses entered by the customer.</em></small>
                        </div>
                        <div className="icon-inside left d-flex btn-with-group">
                            <InputNumber
                                style={{width: "50%"}}
                                precision={0}
                                step={1}
                                value={licenseCount}
                                placeholder="Enter license count"
                                onChange={handleLicenseCountChange}
                            />
                        </div>

                        {/* Warning message under the input */}
                        {showLicenseWarning && (
                            <div style={{ color: "red", marginTop: 4, fontSize: 12 }}>
                                {licenseWarningMessage}
                            </div>
                        )}

                        <div className="validation invalid-feedback">
                            {validator.message(
                                "license count",
                                licenseCount?.toString(),
                                `required|numeric|min:${getLicenseMin()}`
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group__wrapper">
                <div className="form-group">
                    <div className="form-element__wrapper mb-3 ">
                        <label htmlFor="" className="form-label" style={{fontWeight: 600}}>
                            Total subscription monthly rental (without tax & other component fees)
                        </label>
                        <div className="icon-inside left d-flex btn-with-group">
                            <InputNumber
                                value={monthlyRentalData?.monthlyRental || 0}
                                style={{width: "50%"}}
                                bordered={true}
                                readOnly
                                min={0}
                                precision={2}
                                addonBefore="Rs."
                            />
                        </div>
                        <div className="form-element__wrapper mb-3 ">
                            <small style={{marginBottom: 20}}><em>Note : You will receive the final costing including
                                other components later.</em></small>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {PanelTableListCard};
